import { ICrewLogicModifier, IPairingLogicModifier, IPairingsLogicModifierGL } from "@vmosolutions/oc-interfaces";
import { Camera } from "../../../SharedGL/Camera";
import { IDayLogicModifierMap } from "src/redux/reducers/CrewScheduleReducer";

const oneDayMillis = 24 * 1000 * 60 * 60;
export const drawLogicModifiers = (
  canvasCtx: CanvasRenderingContext2D,
  camera: Camera,
  logicModifiers: IDayLogicModifierMap,
  y: number
): void => {
  const [minX, maxX] = camera.getXRange();
  const approxDays = (maxX - minX) / oneDayMillis;
  const approxDayWidth = canvasCtx.canvas.width / approxDays;

  // debugger;
  Object.values(logicModifiers).forEach((dayLogicModifiers: ICrewLogicModifier[]) => {
    if (dayLogicModifiers && Array.isArray(dayLogicModifiers)) {
      const width = approxDayWidth / dayLogicModifiers.length;
      dayLogicModifiers.forEach((logicModifier: ICrewLogicModifier, index: number) => {
        const start = logicModifier.date as unknown as number;
        const startPixel = camera.timeAxisToPixelCoords(start, canvasCtx.canvas.width) + index * width;
        canvasCtx.save();
        canvasCtx.fillStyle = `#${logicModifier.logicModifier.color}`;
        canvasCtx.fillRect(startPixel, y, width, 10);
        canvasCtx.strokeStyle = "black";
        canvasCtx.strokeRect(startPixel, y, width, 10);
        canvasCtx.restore();
      });
    }
  });
};
const radius = 6;
const diameter = 2 * radius;
export const drawPairingLogicModifiers = (
  canvasCtx: CanvasRenderingContext2D,
  camera: Camera,
  pairingLogicModifiers: IPairingsLogicModifierGL[],
  y: number
): void => {
  //need a x for the LM at a pairing level...
  pairingLogicModifiers.forEach((LMs: IPairingsLogicModifierGL) => {
    const groupedLogicModifers: {
      [dutyTime: number]: IPairingLogicModifier[];
    } = {};

    //group the logic modifers by their event groups
    LMs.logicModifiers.forEach((logicModifier: IPairingLogicModifier) => {
      const dutyTime = logicModifier.dutyTime ? new Date(logicModifier.dutyTime).valueOf() : LMs.pairingStart;
      if (groupedLogicModifers[dutyTime]) {
        groupedLogicModifers[dutyTime].push(logicModifier);
      } else {
        groupedLogicModifers[dutyTime] = [logicModifier];
      }
    });

    //make sure you are mapping through them in the order from start - end
    const dutyTimes: number[] = Object.keys(groupedLogicModifers)
      .map((t) => Number(t))
      .sort();

    //before drwaing chech how much space we have between the mid event group and the pairing end or start of the next event group
    dutyTimes.forEach((key, index) => {
      const lms = groupedLogicModifers[key];

      const width = (dutyTimes[index + 1] ?? LMs.pairingEnd) - key;

      const startPixel = camera.timeAxisToPixelCoords(key, canvasCtx.canvas.width);
      const endPixel = camera.timeAxisToPixelCoords(key + width, canvasCtx.canvas.width);
      //can I fit all these guys in fully?
      //if I can't draw each circle fully, then draw the circles overlapping one another
      const idealMinWidth = lms.length * diameter;
      const pixelWidth = endPixel - startPixel;
      const offset = idealMinWidth <= pixelWidth ? diameter : (pixelWidth / idealMinWidth) * diameter;

      lms.forEach((lm, i = 0) => {
        canvasCtx.save();
        canvasCtx.fillStyle = `#${lm.logicModifier.color}`;
        canvasCtx.beginPath();
        canvasCtx.arc(startPixel + i * offset, y - radius, radius, 0, 2 * Math.PI);
        canvasCtx.closePath();
        canvasCtx.fill();
        canvasCtx.strokeStyle = "black";
        canvasCtx.stroke();
        canvasCtx.restore();
      });
    });
  });
};
